import { Navigate, useParams } from 'react-router-dom'
import { PATHS } from '../../shared/config/paths'
import { INSTALL_APP_INTRO, INSTALL_APP_STEPS } from './content/installApp'
import { LOGIN_INTRO, LOGIN_STEPS } from './content/login'
import { TERMIN_ABLAUF_INTRO, TERMIN_ABLAUF_STEPS } from './content/terminAblauf'
import { INSTALL_APP_SLUG, LOGIN_SLUG, TERMIN_ABLAUF_SLUG, findTopic } from './model/topics'
import { useNoIndex } from './model/useNoIndex'
import { DeviceStepsTopic } from './ui/DeviceStepsTopic'
import { GuideLayout } from './ui/GuideLayout'

const DEVICE_TOPICS: Record<string, Pick<Parameters<typeof DeviceStepsTopic>[0], 'intro' | 'steps'>> = {
  [LOGIN_SLUG]: { intro: LOGIN_INTRO, steps: LOGIN_STEPS },
  [TERMIN_ABLAUF_SLUG]: { intro: TERMIN_ABLAUF_INTRO, steps: TERMIN_ABLAUF_STEPS },
  [INSTALL_APP_SLUG]: { intro: INSTALL_APP_INTRO, steps: INSTALL_APP_STEPS },
}

const UserGuideTopicPage = () => {
  useNoIndex()
  const { slug } = useParams()
  const topic = findTopic(slug)
  const content = topic?.ready ? DEVICE_TOPICS[topic.slug] : undefined

  if (!topic || !content) {
    return <Navigate to={PATHS.userGuide} replace />
  }

  return (
    <GuideLayout crumb={topic.title}>
      <DeviceStepsTopic title={topic.title} {...content} />
    </GuideLayout>
  )
}

export default UserGuideTopicPage
